var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImage)?_c('img',{staticClass:"mr-1",attrs:{"src":_vm.value,"width":_vm.size,"height":"auto"}}):_c('b-icon',{staticClass:"mr-1",attrs:{"icon":_vm.value,"custom-size":("mdi-" + _vm.size)}})}
var staticRenderFns = []

export { render, staticRenderFns }